import { UnstyledButton } from "../UnstyledButton.js";
import IconButton_module_default from "./IconButton.module.js";
import { IndicatorIcon } from "../../Icon/IndicatorIcon/IndicatorIcon.js";
import { Tooltip } from "../../Tooltip/Tooltip.js";
import classNames from "classnames";
import React, { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Button/IconButton/IconButton.tsx
/**
* Display an icon as a button. Can render an indicator
*/
var IconButton = forwardRef(function IconButton({ kind = "primary", children, className, indicator, size = "32px", style, disabled, destructive, tooltip, tooltipPlacement, noBackground = false, ...props }, ref) {
	const button = /* @__PURE__ */ jsx(UnstyledButton, {
		as: "button",
		ref,
		className: classNames(IconButton_module_default["icon-button"], className, {
			[IconButton_module_default.destructive]: destructive,
			[IconButton_module_default["no-background"]]: noBackground
		}),
		style: {
			"--cpd-icon-button-size": size,
			...style
		},
		disabled,
		...props,
		"data-indicator": indicator,
		"data-kind": kind,
		children: /* @__PURE__ */ jsx(IndicatorIcon, {
			indicator,
			colour: disabled ? "var(--cpd-color-icon-disabled)" : void 0,
			children: React.Children.only(children)
		})
	});
	return tooltip ? /* @__PURE__ */ jsx(Tooltip, {
		label: tooltip,
		placement: tooltipPlacement,
		children: button
	}) : button;
});
//#endregion
export { IconButton };

//# sourceMappingURL=IconButton.js.map